function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import React from "react";
export var ArrowRight = function(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        width: "15",
        height: "16",
        viewBox: "0 0 15 16",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.6673 8.42462H0L5.00494e-08 6.42462H10.6673L5.65685 1.41421L7.07107 0L14.4957 7.42462L6.71751 15.2028L5.3033 13.7886L10.6673 8.42462Z"
    }));
};

//# sourceMappingURL=ArrowRight.js.map